import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';
import Gap from 'src/components/Gap';
import useEnableRemoteConfig from 'src/hooks/useEnableRemoteConfig';
import { GemProductsResponse } from 'src/types/Payments';
import { getPromotion } from 'src/utils/payments';
import { PromoIcon, PromoRate, PromotionRate, PromotionTextWrap, PromotionTotalRate, PromoTitle, PromoWrapper } from './style';
interface Props {
  gemProducts: GemProductsResponse['gemProducts'];
  bonusGemRates: GemProductsResponse['bonusGemRates'];
}
const ShopPromotionBanner = ({
  gemProducts,
  bonusGemRates
}: Props) => {
  const {
    t
  } = useTranslation();
  const isHideBonusText = !!useEnableRemoteConfig('unexposeWebPgBonusDescription');
  const bonusGemRateText = useMemo(() => bonusGemRates?.map(({
    type,
    rate,
    vipRating
  }) => {
    switch (type) {
      case 'PG_BONUS':
        {
          return t('web_bonus_pg', {
            bonusPercentage: rate
          });
        }
      case 'VIP_BONUS':
        {
          return t('web_banner_benefit_vip', {
            n: rate,
            currentVipLevel: vipRating
          });
        }
      case 'BONUS_COUPON':
        {
          return t('web_bonus_coupon', {
            bonusPercentage: rate
          });
        }
    }
  }), [bonusGemRates, t]);
  const {
    isPromotion,
    promoPercent,
    promoTotalPercent
  } = getPromotion(gemProducts);
  const hasNoBonus = useMemo(() => bonusGemRates?.length === 0, [bonusGemRates]);
  if (hasNoBonus && !isPromotion) {
    return null;
  }
  const promoRate = bonusGemRateText?.join(' + ');
  const promotionRate = `+ ${t('web_bonus_promo', {
    bonusPercentage: promoPercent
  })}`;
  return <PromoWrapper data-sentry-element="PromoWrapper" data-sentry-component="ShopPromotionBanner" data-sentry-source-file="PromotionBanner.tsx">
      <PromoTitle data-sentry-element="PromoTitle" data-sentry-source-file="PromotionBanner.tsx">
        <PromoIcon src='/images/icons/imgGift.png' alt='Gift for web users' data-sentry-element="PromoIcon" data-sentry-source-file="PromotionBanner.tsx" />
        <Gap width={6} data-sentry-element="Gap" data-sentry-source-file="PromotionBanner.tsx" />
        <span>{t(isPromotion ? 'web_promo_title' : 'web_bonus_title')}</span>
      </PromoTitle>
      {!isHideBonusText && <PromotionTextWrap>
          <PromoRate>{promoRate}</PromoRate>
          {isPromotion && <PromotionRate>{promotionRate}</PromotionRate>}
        </PromotionTextWrap>}
      <PromotionTotalRate data-sentry-element="PromotionTotalRate" data-sentry-source-file="PromotionBanner.tsx">
        {t('web_bonus_total', {
        bonusPercentage: promoTotalPercent
      })}
      </PromotionTotalRate>
    </PromoWrapper>;
};
export default ShopPromotionBanner;